(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-rewards"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('black-friday-rewards')) {
    customElements.define(
      'black-friday-rewards',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.layer = this.querySelector('[data-bf-layer]');
          this.dialog = this.querySelector('[data-bf-dialog]');
          this.launcher = this.querySelector('[data-bf-open]');
          this.countdown = this.querySelector('[data-bf-countdown]');
          this.unlockedTrack = this.querySelector('[data-bf-unlocked-track]');
          this.lockedTrack = this.querySelector('[data-bf-locked-track]');
          this.rewards = [...this.querySelectorAll('[data-bf-reward]')];
          this.lastFocusedElement = null;
          this.tick = this.tick.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);

          const now = new Date();
          this.campaignStart = this.parseDate(this.dataset.campaignStart);
          this.campaignEnd = this.parseDate(this.dataset.campaignEnd);
          this.designMode = this.dataset.designMode === 'true' || Boolean(window.Shopify && Shopify.designMode);
          this.previewMode = this.dataset.previewOutsideDates === 'true';
          this.pageMode = this.dataset.pageMode === 'true';
          this.isCampaignActive = this.pageMode || this.designMode || this.previewMode || this.isWithinCampaign(now);

          if (!this.isCampaignActive) return;

          this.hidden = false;
          this.updateRewards(now);
          this.setupCardInteractions();
          this.addEventListener('click', (event) => this.handleClick(event));
          document.addEventListener('keydown', this.handleKeydown);
          this.timer = window.setInterval(this.tick, 1000);

          if (this.pageMode) {
            this.layer.hidden = false;
            this.layer.classList.add('is-open');
            return;
          }

          const delay = Number.parseInt(this.dataset.delay || '0', 10) * 1000;
          const shouldShowOnce = this.dataset.showOnce === 'true';
          const hasDismissed = shouldShowOnce && this.storageKey && localStorage.getItem(this.storageKey) === 'dismissed';

          if (this.designMode || !hasDismissed) {
            this.openTimer = window.setTimeout(() => this.showDialog(), this.designMode ? 0 : delay);
          }
        }

        disconnectedCallback() {
          window.clearInterval(this.timer);
          window.clearTimeout(this.openTimer);
          document.removeEventListener('keydown', this.handleKeydown);
          document.documentElement.classList.remove('lock-all');
        }

        parseDate(value) {
          const date = new Date(value);
          return Number.isNaN(date.getTime()) ? null : date;
        }

        isWithinCampaign(now) {
          if (!this.campaignStart || !this.campaignEnd) return false;
          return now >= this.campaignStart && now < this.campaignEnd;
        }

        setupCardInteractions() {
          const supportsPointerEffects = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!supportsPointerEffects || prefersReducedMotion) return;

          this.rewards.forEach((reward) => {
            reward.addEventListener('pointermove', (event) => {
              if (!reward.classList.contains('is-unlocked')) return;
              const bounds = reward.getBoundingClientRect();
              const x = Math.min(Math.max((event.clientX - bounds.left) / bounds.width, 0), 1);
              const y = Math.min(Math.max((event.clientY - bounds.top) / bounds.height, 0), 1);

              reward.style.setProperty('--bf-tilt-x', `${(0.5 - y) * 8}deg`);
              reward.style.setProperty('--bf-tilt-y', `${(x - 0.5) * 8}deg`);
              reward.style.setProperty('--bf-shine-x', `${x * 100}%`);
              reward.style.setProperty('--bf-shine-y', `${y * 100}%`);
              reward.classList.add('is-tilting');
            });

            reward.addEventListener('pointerleave', () => {
              reward.style.setProperty('--bf-tilt-x', '0deg');
              reward.style.setProperty('--bf-tilt-y', '0deg');
              reward.style.setProperty('--bf-shine-x', '50%');
              reward.style.setProperty('--bf-shine-y', '50%');
              reward.classList.remove('is-tilting');
            });
          });
        }

        updateRewards(now) {
          let latestUnlockedIndex = -1;
          let nextUnlock = null;

          this.rewards.forEach((reward, index) => {
            const unlockAt = this.parseDate(reward.dataset.unlockAt);
            const isUnlocked = Boolean(unlockAt && now >= unlockAt);
            const status = reward.querySelector('[data-bf-status]');
            const unlockDate = reward.querySelector('[data-bf-unlock-date]');
            const flipButton = reward.querySelector('[data-bf-flip]');

            reward.classList.toggle('is-unlocked', isUnlocked);
            reward.classList.toggle('is-locked', !isUnlocked);
            flipButton.disabled = !isUnlocked;

            if (!isUnlocked && reward.classList.contains('is-flipped')) {
              this.flipCard(reward, false, false);
            }

            if (isUnlocked) {
              latestUnlockedIndex = index;
              status.textContent = this.dataset.unlockedLabel;
              unlockDate.hidden = true;
            } else {
              status.textContent = this.dataset.lockedLabel;
              unlockDate.hidden = false;
              unlockDate.textContent = unlockAt
                ? `${this.dataset.unlocksLabel} ${this.formatDate(unlockAt)}`
                : this.dataset.lockedLabel;

              if (unlockAt && (!nextUnlock || unlockAt < nextUnlock)) nextUnlock = unlockAt;
            }
          });

          const rewardVersion = latestUnlockedIndex >= 0 ? latestUnlockedIndex : 'preview';
          this.storageKey = `motech:black-friday:${this.dataset.sectionId}:${rewardVersion}`;

          this.rewards.forEach((reward, index) => {
            reward.classList.toggle('is-current-week', index === latestUnlockedIndex);
            reward.classList.toggle('is-latest-unlocked', index === latestUnlockedIndex && localStorage.getItem(this.storageKey) !== 'dismissed');
          });

          this.organizeRewardTracks();

          this.nextUnlock = nextUnlock;
          this.renderCountdown(now);
        }

        organizeRewardTracks() {
          if (!this.unlockedTrack || !this.lockedTrack) return;

          this.rewards.forEach((reward) => {
            const destination = reward.classList.contains('is-unlocked') ? this.unlockedTrack : this.lockedTrack;
            if (reward.parentElement !== destination) destination.appendChild(reward);
          });
        }

        formatDate(date) {
          return new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', {
            weekday: 'short',
            day: 'numeric',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
          }).format(date);
        }

        renderCountdown(now) {
          if (!this.countdown) return;

          if (!this.nextUnlock) {
            this.countdown.textContent = this.dataset.completeLabel;
            return;
          }

          const remaining = Math.max(0, this.nextUnlock.getTime() - now.getTime());
          const days = Math.floor(remaining / 86400000);
          const hours = Math.floor((remaining % 86400000) / 3600000);
          const minutes = Math.floor((remaining % 3600000) / 60000);
          const seconds = Math.floor((remaining % 60000) / 1000);
          this.countdown.textContent = `${this.dataset.nextLabel}: ${days}${this.dataset.dayLabel} ${String(hours).padStart(2, '0')}${this.dataset.hourLabel} ${String(minutes).padStart(2, '0')}${this.dataset.minuteLabel} ${String(seconds).padStart(2, '0')}${this.dataset.secondLabel}`;
        }

        tick() {
          const now = new Date();

          if (!this.pageMode && !this.designMode && !this.previewMode && !this.isWithinCampaign(now)) {
            this.hideDialog(false);
            this.hidden = true;
            window.clearInterval(this.timer);
            return;
          }

          const previousKey = this.storageKey;
          this.updateRewards(now);

          if (previousKey && previousKey !== this.storageKey) {
            this.unlockAnimationPlayed = false;
            this.focusCurrentReward();
            if (this.dataset.showOnce === 'true') this.showDialog();
          }
        }

        handleClick(event) {
          if (event.target.closest('[data-bf-close]')) {
            this.hideDialog(true);
            return;
          }

          if (event.target.closest('[data-bf-open]')) {
            this.showDialog();
            return;
          }

          const flipBackButton = event.target.closest('[data-bf-flip-back]');
          if (flipBackButton) {
            this.flipCard(flipBackButton.closest('[data-bf-reward]'), false, true);
            return;
          }

          const flipButton = event.target.closest('[data-bf-flip]');
          if (flipButton && !flipButton.disabled) {
            this.flipCard(flipButton.closest('[data-bf-reward]'), true, true);
            return;
          }

          const copyButton = event.target.closest('[data-bf-copy]');
          if (copyButton && !copyButton.closest('.is-locked')) this.copyCode(copyButton);
        }

        flipCard(reward, showBack, moveFocus) {
          if (!reward) return;
          const front = reward.querySelector('[data-bf-flip]');
          const back = reward.querySelector('[data-bf-back]');
          if (!front || !back) return;

          reward.classList.toggle('is-flipped', showBack);
          front.setAttribute('aria-expanded', String(showBack));
          front.tabIndex = showBack ? -1 : 0;
          front.toggleAttribute('inert', showBack);
          back.setAttribute('aria-hidden', String(!showBack));
          back.toggleAttribute('inert', !showBack);

          if (moveFocus) {
            if (showBack) {
              const backTarget = back.querySelector('[data-bf-copy], a[href], [data-bf-flip-back]');
              backTarget?.focus();
            } else {
              front.focus();
            }
          }
        }

        async copyCode(button) {
          const code = button.dataset.code;

          try {
            await navigator.clipboard.writeText(code);
          } catch (error) {
            const input = document.createElement('textarea');
            input.value = code;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }

          const label = button.querySelector('[data-bf-copy-label]');
          label.textContent = this.dataset.copiedLabel;
          window.setTimeout(() => { label.textContent = this.dataset.copyLabel; }, 1800);
        }

        focusCurrentReward() {
          if (!window.matchMedia('(max-width: 740px)').matches) return;

          const reward = this.querySelector('.is-current-week');
          if (!this.dialog || !reward) return;

          const track = reward.closest('[data-bf-unlocked-track]');
          if (track) track.scrollTo({ left: 0, behavior: 'auto' });

          const dialogBounds = this.dialog.getBoundingClientRect();
          const rewardBounds = reward.getBoundingClientRect();
          const targetTop = this.dialog.scrollTop + rewardBounds.top - dialogBounds.top - 12;
          this.dialog.scrollTo({ top: Math.max(0, targetTop), behavior: 'auto' });
        }

        showDialog() {
          if (this.pageMode) return;
          if (!this.layer || !this.layer.hidden) return;
          window.clearTimeout(this.closeTimer);
          const newlyUnlockedReward = this.querySelector('.is-latest-unlocked');
          if (newlyUnlockedReward && !this.unlockAnimationPlayed) {
            newlyUnlockedReward.classList.remove('is-newly-unlocked');
            void newlyUnlockedReward.offsetWidth;
            newlyUnlockedReward.classList.add('is-newly-unlocked');
            this.unlockAnimationPlayed = true;
            window.setTimeout(() => newlyUnlockedReward.classList.remove('is-newly-unlocked'), 3500);
          }
          this.lastFocusedElement = document.activeElement;
          this.layer.hidden = false;
          this.focusCurrentReward();
          this.launcher?.setAttribute('aria-expanded', 'true');
          document.documentElement.classList.add('lock-all');
          window.requestAnimationFrame(() => {
            this.layer.classList.add('is-open');
            this.focusCurrentReward();
            this.dialog.focus();
          });
        }

        hideDialog(rememberDismissal) {
          if (this.pageMode) return;
          if (!this.layer || this.layer.hidden) return;
          this.layer.classList.remove('is-open');
          this.launcher?.setAttribute('aria-expanded', 'false');
          document.documentElement.classList.remove('lock-all');

          if (rememberDismissal && this.dataset.showOnce === 'true' && this.storageKey) {
            localStorage.setItem(this.storageKey, 'dismissed');
          }

          this.closeTimer = window.setTimeout(() => {
            this.layer.hidden = true;
            if (this.lastFocusedElement && document.contains(this.lastFocusedElement)) this.lastFocusedElement.focus();
          }, 360);
        }

        handleKeydown(event) {
          if (!this.layer || this.layer.hidden) return;

          if (event.key === 'Escape') {
            event.preventDefault();
            this.hideDialog(true);
            return;
          }

          if (event.key !== 'Tab') return;
          const focusable = [...this.dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
            .filter((element) => !element.hidden && element.offsetParent !== null);
          if (!focusable.length) return;

          const first = focusable[0];
          const last = focusable[focusable.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
    );
  }

  if (!window.blackFridayRewardsLauncherBound) {
    window.blackFridayRewardsLauncherBound = true;
    document.addEventListener(
      'click',
      (event) => {
        const launcher = event.target.closest('[data-bf-open]');
        if (!launcher) return;

        const component = launcher.closest('black-friday-rewards');
        if (!component) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const layer = component.querySelector('[data-bf-layer]');
        const dialog = component.querySelector('[data-bf-dialog]');
        const newlyUnlockedReward = component.querySelector('.is-latest-unlocked');
        if (!layer || !dialog) return;

        window.clearTimeout(component.closeTimer);
        if (newlyUnlockedReward && !component.unlockAnimationPlayed) {
          newlyUnlockedReward.classList.remove('is-newly-unlocked');
          void newlyUnlockedReward.offsetWidth;
          newlyUnlockedReward.classList.add('is-newly-unlocked');
          component.unlockAnimationPlayed = true;
          window.setTimeout(() => newlyUnlockedReward.classList.remove('is-newly-unlocked'), 3500);
        }

        component.layer = layer;
        component.dialog = dialog;
        component.launcher = launcher;
        component.lastFocusedElement = document.activeElement;
        layer.hidden = false;
        component.focusCurrentReward?.();
        launcher.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('lock-all');
        window.requestAnimationFrame(() => {
          layer.classList.add('is-open');
          dialog.focus();
        });
      },
      true
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  if (!customElements.get('wheel-upsell-trigger')) {
    customElements.define(
      'wheel-upsell-trigger',
      class extends HTMLElement {
        constructor() {
          super();
          this.pendingPopup = false;
          this.onVariantAdded = this.onVariantAdded.bind(this);
          this.onCartRefresh = this.onCartRefresh.bind(this);
        }

        connectedCallback() {
          if (this.dataset.trigger !== 'after_add_to_cart') {
            return;
          }

          document.addEventListener('variant:added', this.onVariantAdded);
          document.documentElement.addEventListener('cart:refresh', this.onCartRefresh, true);
        }

        disconnectedCallback() {
          document.removeEventListener('variant:added', this.onVariantAdded);
          document.documentElement.removeEventListener('cart:refresh', this.onCartRefresh, true);
        }

        onVariantAdded(event) {
          const addedVariant = event.detail && event.detail.variant;
          const sourceForm = event.target.closest && event.target.closest('wheel-upsell-form');

          if (sourceForm || !addedVariant) {
            return;
          }

          if (String(addedVariant.product_id) === this.dataset.productId) {
            this.pendingPopup = true;
          }
        }

        onCartRefresh(event) {
          if (!this.pendingPopup) {
            return;
          }

          this.pendingPopup = false;

          if (event.detail) {
            event.detail.openMiniCart = false;
          }

          const popup = document.getElementById(this.dataset.popupId);

          if (!popup || (popup.onlyOnce && popup.hasAppearedOnce)) {
            return;
          }

          requestAnimationFrame(() => {
            popup.open = true;
          });
        }
      }
    );
  }

  if (!customElements.get('wheel-upsell-form')) {
    customElements.define(
      'wheel-upsell-form',
      class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('variant:added', () => {
            const popup = this.closest('modal-content');

            if (popup) {
              popup.open = false;
            }
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
